"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
const typestyle_1 = require("typestyle");
const Colors_1 = require("../../../../Colors");
const react_1 = __importStar(require("react"));
const Triangle = typestyle_1.style({
    width: 0,
    height: 0,
    borderLeft: `10px solid transparent`,
    borderRight: `10px solid transparent`,
    borderBottom: `15px solid ${Colors_1.Colors.pink[10]}`,
    margin: 'auto',
    marginBottom: -1,
});
const Wrapper = typestyle_1.style({
    zIndex: 4,
    width: 180,
    borderRadius: 4,
});
const Content = typestyle_1.style({
    background: Colors_1.Colors.pink[10],
    borderRadius: 4,
});
exports.Menu = (_a) => {
    var { children, hideMenu } = _a, props = __rest(_a, ["children", "hideMenu"]);
    const menuRef = react_1.useRef(null);
    const [listener, setListener] = react_1.useState();
    react_1.useEffect(() => {
        setListener(() => {
            if (listener) {
                document.removeEventListener('click', listener);
            }
            const l = (e) => {
                if (menuRef.current && e.target && !menuRef.current.contains(e.target)) {
                    document.removeEventListener('click', l);
                    hideMenu();
                    return;
                }
            };
            document.addEventListener('click', l);
            return l;
        });
        return () => {
            if (listener) {
                document.removeEventListener('click', listener);
            }
        };
    }, [menuRef]);
    return (react_1.default.createElement("div", Object.assign({}, props, { className: Wrapper, ref: menuRef }),
        react_1.default.createElement("div", { className: Triangle }),
        react_1.default.createElement("div", { className: Content }, children)));
};
